import React from 'react';
import './FinanceHero.css';

const FinanceHero = () => {
  return (
    <section className="finance-hero">
      <div className="finance-hero-overlay">
        <div className="finance-hero-content">
          <h1>Finance & Accounts Department</h1>
          <p>Promoting transparency, accountability, and sustainable financial management in Igbo-Eze North.</p>
        </div>
      </div>
    </section>
  );
};

export default FinanceHero;